import { createAction } from 'redux-actions';
import { authFetch } from '../AuthFetch';

export const changeDownloadItemsValue = createAction('CHANGE_DOWNLOAD_ITEMS_VALUE');
export const cleanDownloadItemsAlert = createAction('CLEAN_DOWNLOAD_ITEMS_ALERT');

export const generateItemsFile = (bean) => (
    (dispatch) => {
        dispatch({
            type: 'BEFORE_GENERATE_DOWNLOAD_ITEMS'
        });
        let url = '/firefighter/download/itemData';
        authFetch('POST', url, JSON.stringify(bean), (json) => {
            dispatch({
                type: 'AFTER_GENERATE_DOWNLOAD_ITEMS',
                payload: json
            });
        });
    }
);

export const generateItemsFile2 = (bean) => (
    (dispatch) => {
        dispatch({
            type: 'BEFORE_GENERATE_DOWNLOAD_ITEMS'
        });
        let url = '/firefighter/download/itemData2';
        authFetch('POST', url, JSON.stringify(bean), (json) => {
            dispatch({
                type: 'AFTER_GENERATE_DOWNLOAD_ITEMS',
                payload: json
            });
        });
    }
);

export const findOrdersWithShipment = () => (
    (dispatch) => {
        let url = '/firefighter/download/orders';
        authFetch('GET', url, null, (json) => {
            dispatch({
                type: 'FIND_ORDERS_WITH_SHIPMENT',
                payload: json
            });
        });
    }
);


// WEBPACK FOOTER //
// ./src/actions/downloadItemsActions.js